module.exports = __webpack_public_path__ + "static/media/Blissey_gaussian2.853c5653.png";